import {
	Accordion,
	AccordionButton,
	AccordionIcon,
	AccordionItem,
	AccordionPanel,
} from "@chakra-ui/accordion";
import { Button, IconButton } from "@chakra-ui/button";
import { FormControl, FormLabel } from "@chakra-ui/form-control";
import { useDisclosure } from "@chakra-ui/hooks";
import { AddIcon } from "@chakra-ui/icons";
import { Input } from "@chakra-ui/input";
import { Badge, Box, Divider, Flex, Heading, Text } from "@chakra-ui/layout";
import {
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
} from "@chakra-ui/modal";
import { Textarea } from "@chakra-ui/textarea";
import { useToast } from "@chakra-ui/toast";
import { useEffect, useRef, useState } from "react";
import theme from "../helpers/theme";

export const SidebarView = ({ isAdmin, clubRef }) => {
	const [events, setEvents] = useState([]);

	const toast = useToast();

	const { isOpen, onOpen, onClose } = useDisclosure();

	const titleRef = useRef();
	const descriptionRef = useRef();
	const typeRef = useRef();

	useEffect(() => {
		const unsubscribe = clubRef
			.collection("events")
			.orderBy("created")
			.limit(50)
			.onSnapshot(events => {
				const docs = events.docs;
				const filteredDocs = docs.map(doc => doc.data());
				setEvents(filteredDocs.reverse());
				console.log(filteredDocs);
			});

		return unsubscribe;
	}, [clubRef]);

	const createEvent = e => {
		e.preventDefault();

		const title = titleRef.current.value;
		const description = descriptionRef.current.value;
		const type = typeRef.current.value;

		if (title.length < 3 || description.length < 3)
			toast({
				title: "Title or description too short",
				description: "Please include a longer description / title",
				status: "error",
			});

		if (type.length > 10)
			toast({
				title: "Type too long",
				description: "Please include a shorter type field",
				status: "error",
			});

		// push to firebase
		clubRef.collection("events").add({
			title,
			description,
			type,
			created: Date.now(),
		});

		titleRef.current.value = "";
		descriptionRef.current.value = "";
		typeRef.current.value = "";

		onClose();
	};

	// ge the stuffs
	return (
		<>
			<Modal isOpen={isOpen} onClose={onClose} isCentered>
				<ModalOverlay />
				<ModalContent>
					<ModalHeader>Create Event</ModalHeader>
					<ModalCloseButton />
					<form onSubmit={createEvent}>
						<ModalBody>
							<FormControl>
								<FormLabel>Title</FormLabel>
								<Input
									rounded="full"
									bgColor="gray.100"
									border="none"
									_focusWithin={{
										backgroundColor: "white",
									}}
									focusBorderColor={
										theme.colours.accent + ".400"
									}
									ref={titleRef}
									placeholder="Meeting with mrs emilia"
								/>
							</FormControl>
							<FormControl mt={3}>
								<FormLabel>Description</FormLabel>
								<Textarea
									rounded="lg"
									bgColor="gray.100"
									border="none"
									_focusWithin={{
										backgroundColor: "white",
									}}
									focusBorderColor={
										theme.colours.accent + ".400"
									}
									ref={descriptionRef}
									placeholder="a big day for all of us"
								/>
							</FormControl>
							<FormControl mt={3}>
								<FormLabel>Type</FormLabel>
								<Input
									rounded="full"
									bgColor="gray.100"
									border="none"
									_focusWithin={{
										backgroundColor: "white",
									}}
									focusBorderColor={
										theme.colours.accent + ".400"
									}
									ref={typeRef}
									placeholder="eg. 'meeting', keep it short!"
								/>
							</FormControl>
						</ModalBody>

						<ModalFooter>
							<Button
								colorScheme={theme.colours.accent}
								variant="ghost"
								mr={3}
								type="submit"
								rounded="full"
							>
								Create Event
							</Button>
							<Button
								rounded="full"
								variant="ghost"
								type="button"
								onClick={onClose}
							>
								Quit
							</Button>
						</ModalFooter>
					</form>
				</ModalContent>
			</Modal>

			<Box
				rounded="lg"
				bgColor="gray.100"
				p="1.5rem"
				userSelect="none"
				mt={{ base: 0, lg: "5.3rem" }}
			>
				<Flex justifyContent="space-between" alignItems="center">
					<Heading size="md" mb={3}>
						Events
					</Heading>
					{isAdmin && (
						<IconButton
							mb={2}
							icon={<AddIcon />}
							rounded="full"
							size="sm"
							colorScheme="green"
							transition="box-shadow 200ms"
							onClick={onOpen}
							_hover={{
								boxShadow: "0 2px 5px -1px gray",
							}}
						/>
					)}
				</Flex>
				<Divider />
				{!events || events.length < 1 ? (
					<Heading size="sm">No events currently.</Heading>
				) : (
					events.map((event, key) => (
						<Accordion allowToggle mt={5} key={key}>
							<AccordionItem>
								<AccordionButton
									as={Box}
									p={0}
									w="100%"
									bg="none !important"
								>
									<Flex
										p="1rem"
										w="100%"
										bgColor="white"
										rounded="full"
										justifyContent="center"
										alignItems="space-between"
										flexDir="column"
										cursor="pointer"
										transition="box-shadow 250ms"
										_hover={{
											boxShadow: "0 2px 5px -3px gray",
										}}
									>
										<Flex
											justifyContent="space-between"
											alignItems="center"
										>
											<Heading size="sm">
												{key === 0
													? `Upcoming: ${event.title}`
													: event.title}
											</Heading>
											<Flex
												justifyContent="space-between"
												alignItems="center"
											>
												<Badge
													borderRadius="full"
													px="2"
													mr="2"
													colorScheme="blue"
												>
													{event.type}
												</Badge>
												{/* <IconButton
										variant="ghost"
										rounded="full"
										icon={<ChevronDownIcon />}
									/> */}
												<AccordionIcon />
											</Flex>
										</Flex>
									</Flex>
								</AccordionButton>
								<AccordionPanel>
									<Text fontSize="md">
										{event.description}
									</Text>
								</AccordionPanel>
							</AccordionItem>
						</Accordion>
					))
				)}
			</Box>
		</>
	);
};
